"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockReportStatus = exports.mockGetReportStatus = exports.mockGetReports = void 0;
var interfaces_1 = require("../../interfaces");
var mockGetReports = function () {
    var data = [
        {
            uuid: '1',
            name: 'Row 1',
            source: 'Activity Feed',
            createdAt: '2024-01-03',
            status: interfaces_1.ReportStatus.IN_PROGRESS,
            isViewed: false,
        },
        {
            uuid: '2',
            name: 'Activity report 2024-01-10T13:35:13.160Z',
            source: 'Activity Feed',
            createdAt: '2024-01-04',
            status: interfaces_1.ReportStatus.ERROR,
            isViewed: true,
        },
        {
            uuid: '3',
            name: 'Row 1',
            source: 'Activity Feed',
            createdAt: '2024-01-03',
            status: interfaces_1.ReportStatus.COMPLETED,
            isViewed: false,
        },
        {
            uuid: '4',
            name: 'Row 1',
            source: 'Activity Feed',
            createdAt: '2024-01-03',
            status: interfaces_1.ReportStatus.FAILED_TO_DELETE,
            isViewed: true,
        },
        {
            uuid: '5',
            name: 'Row 1',
            source: 'Activity Feed',
            createdAt: '2024-01-03',
            status: interfaces_1.ReportStatus.COMPLETED,
            isViewed: true,
        },
        {
            uuid: '6',
            name: 'Row 1',
            source: 'Activity Feed',
            createdAt: '2024-01-03',
            status: interfaces_1.ReportStatus.COMPLETED,
            isViewed: true,
        },
        {
            uuid: '7',
            name: 'Row 1',
            source: 'Activity Feed',
            createdAt: '2024-01-03',
            status: interfaces_1.ReportStatus.COMPLETED,
            isViewed: true,
        },
    ];
    return { success: true, reports: data, total: data.length };
};
exports.mockGetReports = mockGetReports;
exports.mockGetReportStatus = {
    success: true,
    reports: [
        {
            uuid: '1',
            status: interfaces_1.ReportStatus.COMPLETED,
            isViewed: false,
        },
        {
            uuid: '2',
            status: interfaces_1.ReportStatus.IN_PROGRESS,
            isViewed: true,
        },
        {
            uuid: '3',
            status: interfaces_1.ReportStatus.ERROR,
            isViewed: true,
        },
    ],
};
exports.mockReportStatus = {
    status: interfaces_1.ReportStatus.COMPLETED,
    uuid: 'ewjriewrewq2930213',
};
